import { styled } from '@mui/material/styles';

export const Container = styled('div')`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
`;
